var cov_2bwfb00e4h = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Cascader/styles/index.ts",
      hash = "b76f1c4ae399455460121946929e30f9a667b961",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Cascader/styles/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 29
        },
        end: {
          line: 5,
          column: 65
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var cascaderLess = {};
import genaration from '../../utils/classname';
export var cascaderClass = (cov_2bwfb00e4h.s[0]++, genaration(cascaderLess, 'cascader'));